<template>
  <!-- rf05 -->
  <v-content class="pa-12">
    <v-layout style="background-color: #FAF5F2;">
      <v-flex>
        <v-flex shrink style="text-align: right"><v-btn dark @click="printPage()"
            style="width: 80px; background-color: black;"><v-icon>local_printshop</v-icon></v-btn></v-flex>
        <v-layout mb-4>
          <v-flex style="font-size: 28px;font-weight: bold;color: #737373">
            <span>แบบฟอร์ม</span>
          </v-flex>
        </v-layout>

        <div id="print" style="height: auto">
          <div class="print-form">
            <v-layout mx-6>
              <v-flex>
                <v-layout style="background-color: #3E7662;">
                  <v-flex my-4 ml-8 style="text-align: left;font-size: 28px;color: white" @click="setData">
                    <div style="font-weight: bold">
                      แบบประเมินรายงานการไม่ปฏิบัติตามข้อกำหนด
                    </div>
                    <div style="font-size: 18px;">
                      Assessment of Non-compliance/Protocol Deviation/ Violation
                    </div>
                  </v-flex>
                  <v-flex ml-8 pt-8 pr-8 style="text-align: right;font-weight: bold;font-size: 13px;color: white">
                    <span>RO 08_2563 </span>
                  </v-flex>
                </v-layout>

                <!-- Start Form -->

                <!-- Card 1 -->
                <v-card class="mb-8">
                  <v-layout pa-12 class="justify-center">
                    <v-flex xs10>
                      <!-- row 1 -->
                      <v-layout mb-8>
                        <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                          <b>รหัสโครงร่างการวิจัย</b>
                        </v-flex>
                        <v-flex xs4 class="text-start">
                          <TextfieldForm readonly :model="form.researchCode" hide-detail
                            @update-data="updateData('researchCode', $event)" />
                        </v-flex>
                        <v-spacer></v-spacer>
                      </v-layout>
                      <!-- row 2 -->
                      <v-layout mb-8>
                        <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                          <b>ชื่อผู้วิจัยหลัก</b>
                        </v-flex>
                        <v-flex xs4 class="text-start">
                          <TextfieldForm readonly :model="form.firstName" hide-detail
                            @update-data="updateData('firstName', $event)" />
                        </v-flex>
                        <v-flex mx-4 xs1 class="d-flex justify-end align-center">
                          <b>นามสกุล</b>
                        </v-flex>
                        <v-flex>
                          <TextfieldForm readonly :model="form.lastName" hide-detail
                            @update-data="updateData('lastName', $event)" />
                        </v-flex>
                      </v-layout>
                      <!-- row 3 -->
                      <v-layout>
                        <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                          <b>ชื่อโครงการวิจัย (ไทย)</b>
                        </v-flex>
                        <v-flex>
                          <textarea-form hide-detail :model="form.researchName"
                            @update-data="updateData('researchName', $event)"></textarea-form>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>

                <div class="d-flex justify-start mb-8">
                  <v-dialog max-width="800">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="#3e7662" dark v-bind="attrs"
                        v-on="on">แบบรายงานการไม่ปฏิบัติตามข้อกำหนดทั้งหมด</v-btn>
                    </template>

                    <template v-slot:default="dialog">
                      <v-card>
                        <v-toolbar style="font-size: 1.5rem;" class="font-weight-bold" color="#3e7662"
                          dark>แบบรายงานการไม่ปฏิบัติตามข้อกำหนดทั้งหมด</v-toolbar>
                        <v-card-text class="text-start">
                          <div class=" pa-6">
                            <v-simple-table>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th style="font-size: 16px" class="text-left">
                                      แบบรายงานการไม่ปฏิบัติตามข้อกำหนด (RF 05_2563)
                                    </th>
                                    <th style="font-size: 16px" class="text-center">
                                      Version
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="item in allFormRf05" :key="item.id">
                                    <td class="text-left link-hover" style="cursor: pointer;" @click="
                                      viewFormRf05(item.researchID, item.id)
                                      ">
                                      <span>
                                        เรื่องที่ {{ item.group_id + 1 }}
                                      </span>
                                    </td>
                                    <td class="text-center">
                                      {{ item.version }}
                                    </td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </div>
                        </v-card-text>
                        <v-card-actions class="justify-end">
                          <v-btn depressed dark color="#3e7662" @click="dialog.value = false"
                            class="font-weight-bold">ปิด</v-btn>
                        </v-card-actions>
                      </v-card>
                    </template>
                  </v-dialog>
                </div>

                <v-card class="py-12 px-4 mb-12">
                  <v-layout class="justify-space-around">
                    <v-flex class="mr-4 shrink d-flex align-center">
                      <span>จำนวนรายงาน</span>
                    </v-flex>
                    <v-flex class="xs3">
                      <TextfieldForm :readonly="$route.query.read == 1 ? true : false" :model="form.numberOfReport"
                        hide-detail @update-data="updateData('numberOfReport', $event)" />
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex class="mr-4 shrink d-flex align-center">
                      <span>จำนวนอาสาสมัครที่มีการไม่ปฏิบัติตามข้อกำหนด</span>
                    </v-flex>
                    <v-flex class="xs3">
                      <TextfieldForm :readonly="$route.query.read == 1 ? true : false" :model="form.numberOfVolunteer"
                        hide-detail @update-data="updateData('numberOfVolunteer', $event)" />
                    </v-flex>
                  </v-layout>
                </v-card>

                <!-- Card 2 Type of Report -->
                <v-card class="mb-12" style="padding-bottom: 5rem">
                  <v-layout py-4 style="background-color: #3E7662;color: white;font-weight: bold">
                    <v-flex>
                      <span>Type of Report</span>
                    </v-flex>
                  </v-layout>

                  <v-layout pa-12>
                    <v-flex>
                      <!-- Form Checkbox 1 -->
                      <v-layout>
                        <v-flex xs3 class="text-start">
                          <v-checkbox :readonly="$route.query.read == 1 ? true : false" v-model="checkbox1"
                            label="Protocol Deviation" color="#3E7662" hide-details></v-checkbox>
                        </v-flex>
                        <v-flex xs3 class="text-start">
                          <v-checkbox :readonly="$route.query.read == 1 ? true : false" v-model="checkbox2"
                            label="Protocol Violation" color="#3E7662" hide-details></v-checkbox>
                        </v-flex>
                        <v-spacer></v-spacer>
                      </v-layout>

                      <!-- row 1 -->
                      <v-layout mt-12 ml-6>
                        <v-flex shrink class="text-start d-flex align-center">
                          <v-checkbox :readonly="$route.query.read == 1 ? true : false" :disabled="!checkbox1"
                            @click.native="clearCheckbox('has1')" v-model="form.has1"
                            label="สุ่มอาสาสมัครที่ไม่มีคุณสมบัติเหมาะสม" color="#3E7662" hide-details></v-checkbox>
                        </v-flex>
                        <v-flex mx-2 class="text-start d-flex align-center mt-n3 text-field-center">
                          <v-text-field :readonly="$route.query.read == 1 ? true : false" :disabled="!form.has1"
                            hide-details color="#3E7662" v-model="form.event1" />
                        </v-flex>
                        <v-flex shrink class="text-start d-flex align-center">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>
                      <!-- row 2 -->
                      <v-layout mt-4 ml-6>
                        <v-flex shrink class="text-start d-flex align-center">
                          <v-checkbox :readonly="$route.query.read == 1 ? true : false" :disabled="!checkbox1"
                            @click.native="clearCheckbox('has2')" v-model="form.has2"
                            label="รับอาสาสมัครที่เข้าข่ายคัดออกจากโครงการ" color="#3E7662" hide-details></v-checkbox>
                        </v-flex>
                        <v-flex mx-2 class="text-start d-flex align-center mt-n3 text-field-center">
                          <v-text-field :readonly="$route.query.read == 1 ? true : false" :disabled="!form.has2"
                            hide-details color="#3E7662" v-model="form.event2" />
                        </v-flex>
                        <v-flex shrink class="text-start d-flex align-center">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>
                      <!-- row 3 -->
                      <v-layout mt-4 ml-6>
                        <v-flex shrink class="text-start d-flex align-center">
                          <v-checkbox :readonly="$route.query.read == 1 ? true : false" :disabled="!checkbox1"
                            @click.native="clearCheckbox('has3')" v-model="form.has3"
                            label="ไม่ได้ทำตามขั้นตอนการคัดกรองที่ระบุ" color="#3E7662" hide-details></v-checkbox>
                        </v-flex>
                        <v-flex mx-2 class="text-start d-flex align-center mt-n3 text-field-center">
                          <v-text-field :readonly="$route.query.read == 1 ? true : false" :disabled="!form.has3"
                            hide-details color="#3E7662" v-model="form.event3" />
                        </v-flex>
                        <v-flex shrink class="text-start d-flex align-center">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>

                      <v-layout mt-4 ml-6>
                        <v-flex shrink class="text-start d-flex align-center">
                          <v-checkbox :readonly="$route.query.read == 1 ? true : false" :disabled="!checkbox1"
                            @click.native="clearCheckbox('has6')" v-model="form.has6"
                            label="ดำเนินการคัดกรองหรือขั้นตอนการวิจัย นอกระยะเวลาที่ระบุ" color="#3E7662"
                            hide-details></v-checkbox>
                        </v-flex>
                        <v-flex mx-2 class="text-start d-flex align-center mt-n3 text-field-center">
                          <v-text-field :readonly="$route.query.read == 1 ? true : false" :disabled="!form.has6"
                            hide-details color="#3E7662" v-model="form.event6" />
                        </v-flex>
                        <v-flex shrink class="text-start d-flex align-center">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>
                      <!-- row 4 -->
                      <v-layout mt-4 ml-6>
                        <v-flex shrink class="text-start d-flex align-center">
                          <v-checkbox :readonly="$route.query.read == 1 ? true : false" :disabled="!checkbox1"
                            @click.native="clearCheckbox('has4')" v-model="form.has4"
                            label="ให้การรักษาหรือให้ยาไม่ตรงตามที่ระบุ" color="#3E7662" hide-details></v-checkbox>
                        </v-flex>
                        <v-flex mx-2 class="text-start d-flex align-center mt-n3 text-field-center">
                          <v-text-field :readonly="$route.query.read == 1 ? true : false" :disabled="!form.has4"
                            hide-details color="#3E7662" v-model="form.event4" />
                        </v-flex>
                        <v-flex shrink class="text-start d-flex align-center">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>
                      <!-- row 5 -->
                      <v-layout mt-4 ml-6>
                        <v-flex shrink class="text-start d-flex align-center">
                          <v-checkbox :readonly="$route.query.read == 1 ? true : false" :disabled="!checkbox1"
                            @click.native="clearCheckbox('has5')" v-model="form.has5"
                            label="ทำหัตถการวิจัยที่ระบุไว้ไม่ครบถ้วน" color="#3E7662" hide-details></v-checkbox>
                        </v-flex>
                        <v-flex mx-2 class="text-start d-flex align-center mt-n3 text-field-center">
                          <v-text-field :readonly="$route.query.read == 1 ? true : false" :disabled="!form.has5"
                            hide-details color="#3E7662" v-model="form.event5" />
                        </v-flex>
                        <v-flex shrink class="text-start d-flex align-center">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>
                      <!-- row 6 -->

                      <v-layout mt-4 ml-6>
                        <v-flex shrink class="text-start d-flex align-center">
                          <v-checkbox :readonly="$route.query.read == 1 ? true : false" :disabled="!checkbox1"
                            @click.native="clearCheckbox('has8')" v-model="form.has8" label="นัดหมายไม่ตรงตามระบุ"
                            color="#3E7662" hide-details></v-checkbox>
                        </v-flex>
                        <v-flex mx-2 class="text-start d-flex align-center mt-n3 text-field-center">
                          <v-text-field :readonly="$route.query.read == 1 ? true : false" :disabled="!form.has8"
                            hide-details color="#3E7662" v-model="form.event8" />
                        </v-flex>
                        <v-flex shrink class="text-start d-flex align-center">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>

                      <!-- row 7 -->
                      <v-layout mt-4 ml-6>
                        <v-flex shrink class="text-start d-flex align-center">
                          <v-checkbox :readonly="$route.query.read == 1 ? true : false" :disabled="!checkbox1"
                            @click.native="clearCheckbox('has7')" v-model="form.has7" label="อื่นๆ (Others) ระบุ "
                            color="#3E7662" hide-details></v-checkbox>
                        </v-flex>
                        <v-flex mx-2 class="text-start d-flex align-center mt-n3 text-field-center">
                          <v-text-field :readonly="$route.query.read == 1 ? true : false" :disabled="!form.has7"
                            hide-details color="#3E7662" v-model="form.event7" />
                        </v-flex>
                        <!-- <v-flex shrink class="text-start d-flex align-center">
                      <span>เหตุการณ์</span>
                    </v-flex> -->
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <v-layout pa-12>
                    <v-flex>
                      <!-- Form Checkbox 1 -->
                      <v-layout>
                        <v-flex xs3 class="text-start">
                          <v-checkbox :readonly="$route.query.read == 1 ? true : false" v-model="checkbox3"
                            label="Non-Compliance" color="#3E7662" hide-details></v-checkbox>
                        </v-flex>
                      </v-layout>

                      <!-- row 1 -->
                      <v-layout mt-12 ml-6>
                        <v-flex shrink class="text-start d-flex align-center">
                          <v-checkbox readonly v-if="$route.query.read == 1" v-model="form.has9"
                            label="ส่งรายงานเหตุการณ์ไม่พึงประสงค์ชนิดร้ายแรงล่าช้า" color="#3E7662"
                            hide-details></v-checkbox>
                          <v-checkbox v-else :disabled="!checkbox3" @click.native="clearCheckbox('has9')"
                            v-model="form.has9" label="ส่งรายงานเหตุการณ์ไม่พึงประสงค์ชนิดร้ายแรงล่าช้า" color="#3E7662"
                            hide-details></v-checkbox>
                        </v-flex>
                        <v-flex mx-2 class="text-start d-flex align-center mt-n3 text-field-center">
                          <v-text-field :readonly="$route.query.read == 1 ? true : false"
                            :disabled="!form.has9 || !checkbox3" hide-details color="#3E7662" v-model="form.event9" />
                        </v-flex>
                        <v-flex shrink class="text-start d-flex align-center">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>
                      <!-- row 2 -->
                      <v-layout mt-4 ml-6>
                        <v-flex shrink class="text-start d-flex align-center">
                          <v-checkbox readonly v-if="$route.query.read == 1" v-model="form.has10"
                            label="ส่งรายงานความก้าวหน้าของการวิจัยล่าช้า" color="#3E7662" hide-details></v-checkbox>
                          <v-checkbox v-else :disabled="!checkbox3" @click.native="clearCheckbox('has10')"
                            v-model="form.has10" label="ส่งรายงานความก้าวหน้าของการวิจัยล่าช้า" color="#3E7662"
                            hide-details></v-checkbox>
                        </v-flex>
                        <v-flex mx-2 class="text-start d-flex align-center mt-n3 text-field-center">
                          <v-text-field :readonly="$route.query.read == 1 ? true : false"
                            :disabled="!form.has10 || !checkbox3" hide-details color="#3E7662" v-model="form.event10" />
                        </v-flex>
                        <v-flex shrink class="text-start d-flex align-center">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>
                      <!-- row 3 -->
                      <v-layout mt-4 ml-6>
                        <v-flex shrink class="text-start d-flex align-center">
                          <v-checkbox :readonly="$route.query.read == 1 ? true : false" :disabled="!checkbox3"
                            @click.native="clearCheckbox('has11')" v-model="form.has11"
                            label="ใช้เอกสารชี้แจงข้อมูลแก่อาสาสมัครฉบับที่ไม่ประทับตรายางของคณะอนุกรรมการฯ"
                            color="#3E7662" hide-details></v-checkbox>
                        </v-flex>
                        <v-flex mx-2 class="text-start d-flex align-center mt-n3 text-field-center">
                          <v-text-field :readonly="$route.query.read == 1 ? true : false"
                            :disabled="!form.has11 || !checkbox3" hide-details color="#3E7662" v-model="form.event11" />
                        </v-flex>
                        <v-flex shrink class="text-start d-flex align-center">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>
                      <!-- row 4 -->
                      <v-layout mt-4 ml-6>
                        <v-flex shrink class="text-start d-flex align-center">
                          <v-checkbox :readonly="$route.query.read == 1 ? true : false" :disabled="!checkbox3"
                            @click.native="clearCheckbox('has12')" v-model="form.has12"
                            label="การบริหารจัดการผลิตภัณฑ์ยาที่ใช้ในการวิจัยไม่เหมาะสม" color="#3E7662"
                            hide-details></v-checkbox>
                        </v-flex>
                        <v-flex mx-2 class="text-start d-flex align-center mt-n3 text-field-center">
                          <v-text-field :readonly="$route.query.read == 1 ? true : false"
                            :disabled="!form.has12 || !checkbox3" hide-details color="#3E7662" v-model="form.event12" />
                        </v-flex>
                        <v-flex shrink class="text-start d-flex align-center">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>
                      <!-- row 5 -->
                      <v-layout mt-4 ml-6>
                        <v-flex shrink class="text-start d-flex align-center">
                          <v-checkbox :readonly="$route.query.read == 1 ? true : false" :disabled="!checkbox3"
                            @click.native="clearCheckbox('has13')" v-model="form.has13" label="อื่นๆ (Others) ระบุ"
                            color="#3E7662" hide-details></v-checkbox>
                        </v-flex>
                        <v-flex mx-2 class="text-start d-flex align-center mt-n3 text-field-center">
                          <v-text-field :readonly="$route.query.read == 1 ? true : false"
                            :disabled="!form.has13 || !checkbox3" hide-details color="#3E7662" v-model="form.event13" />
                        </v-flex>
                        <!-- <v-flex shrink class="text-start d-flex align-center">
                      <span>เหตุการณ์</span>
                    </v-flex> -->
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!-- Card 3 -->
                <v-card class="mb-12">
                  <v-layout py-4 style="background-color: #3E7662;color: white;font-weight: bold">
                    <v-flex>
                      <span>ผลการประเมิน</span>
                    </v-flex>
                  </v-layout>

                  <v-layout pa-12>
                    <v-flex class="text-start">
                      <!-- 1. มีความเสี่ยงหรืออันตรายต่ออาสาสมัครหรือไม่ -->
                      <v-layout mt-12>
                        <v-flex class="text-start font-weight-bold">
                          <span>1. มีความเสี่ยงหรืออันตรายต่ออาสาสมัครหรือไม่</span>
                        </v-flex>
                      </v-layout>
                      <v-layout class="ml-6 mt-4">
                        <v-flex>
                          <v-radio-group v-model="form.isRisk" row :readonly="$route.query.read == 1 ? true : false">
                            <v-radio v-if="$route.query.read == 1" class="mb-4" color="#3E7662" label="ไม่มี"
                              value="1"></v-radio>
                            <v-radio v-else @click.native="clearRadio('isRisk')" class="mb-4" color="#3E7662"
                              label="ไม่มี" value="1"></v-radio>
                            <v-row class="mt-n3 ml-12">
                              <v-col cols="auto">
                                <v-radio color="#3E7662" label="มีระบุ" value="2"></v-radio>
                              </v-col>
                              <v-col style="flex: 1;padding-left: 0">
                                <v-text-field :readonly="$route.query.read == 1 ? true : false"
                                  :disabled="form.isRisk !== '2'" color="#3E7662" class="mt-n4" v-model="form.risk"
                                  hide-details />
                              </v-col>
                            </v-row>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>
                      <!-- 2. มีผลกระทบต่อคุณภาพงานวิจัย (scientific integrity) หรือไม่ -->
                      <v-layout mt-8>
                        <v-flex class="text-start font-weight-bold">
                          <span>2. มีผลกระทบต่อคุณภาพงานวิจัย (scientific integrity)
                            หรือไม่</span>
                        </v-flex>
                      </v-layout>
                      <v-layout class="ml-6 mt-4">
                        <v-flex>
                          <v-radio-group v-model="form.isScientific" row
                            :readonly="$route.query.read == 1 ? true : false">
                            <v-radio v-if="$route.query.read == 1" class="mb-4" color="#3E7662" label="ไม่มี"
                              value="1"></v-radio>
                            <v-radio v-else @click.native="clearRadio('isScientific')" class="mb-4" color="#3E7662"
                              label="ไม่มี" value="1"></v-radio>
                            <v-row class="mt-n3 ml-12">
                              <v-col cols="auto">
                                <v-radio color="#3E7662" label="มีระบุ" value="2"></v-radio>
                              </v-col>
                              <v-col style="flex: 1;padding-left: 0">
                                <v-text-field :disabled="form.isScientific !== '2'" color="#3E7662" class="mt-n4"
                                  v-model="form.scientific" hide-details />
                              </v-col>
                            </v-row>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>
                      <!-- 3. การไม่ปฏิบัติตามข้อกำหนดนี้ เป็นผลมาจากความตั้งใจหรือเจตนาของผู้วิจัยหรือไม่ -->
                      <v-layout mt-10>
                        <v-flex class="text-start font-weight-bold">
                          <span>3. การไม่ปฏิบัติตามข้อกำหนดนี้
                            เป็นผลมาจากความตั้งใจหรือเจตนาของผู้วิจัยหรือไม่</span>
                        </v-flex>
                      </v-layout>
                      <v-layout class="ml-6 mt-4">
                        <v-flex>
                          <v-radio-group :readonly="$route.query.read == 1 ? true : false" v-model="form.isIntend" row>
                            <v-radio style="padding-right: 70px" color="#3E7662" label="ใช่" value="1"></v-radio>
                            <v-radio color="#3E7662" label="ไม่ใช่" value="2"></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>
                      <!-- 4. ผู้วิจัยละเลยการปฏิบัติตามขั้นตอนการวิจัยหรือตามหลักจริยธรรมการวิจัยหรือไม่ -->
                      <v-layout mt-10>
                        <v-flex class="text-start font-weight-bold">
                          <span>4.
                            ผู้วิจัยละเลยการปฏิบัติตามขั้นตอนการวิจัยหรือตามหลักจริยธรรมการวิจัยหรือไม่</span>
                        </v-flex>
                      </v-layout>
                      <v-layout class="ml-6 mt-4">
                        <v-flex>
                          <v-radio-group :readonly="$route.query.read == 1 ? true : false" v-model="form.isIgnore" row>
                            <v-radio style="padding-right: 70px" color="#3E7662" label="ไม่ละเลย" value="1"></v-radio>
                            <v-radio color="#3E7662" label="ละเลย" value="2"></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>
                      <!-- 5. การแก้ไขเหตุการณ์โดยผู้วิจัย เหมาะสมหรือไม่ -->
                      <v-layout mt-10>
                        <v-flex class="text-start font-weight-bold">
                          <span>5. การแก้ไขเหตุการณ์โดยผู้วิจัย เหมาะสมหรือไม่</span>
                        </v-flex>
                      </v-layout>
                      <v-layout class="ml-6 mt-4">
                        <v-flex>
                          <v-radio-group :readonly="$route.query.read == 1 ? true : false" v-model="form.isAppropriate"
                            row>
                            <v-radio style="padding-right: 70px" color="#3E7662" label="เหมาะสม" value="1"></v-radio>
                            <v-radio color="#3E7662" label="ไม่เหมาะสม" value="2"></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>
                      <!-- 6. แผนการแก้ปัญหา ช่วยลดโอกาสเกิดซ้ำ หรือไม่ -->
                      <v-layout mt-10>
                        <v-flex class="text-start font-weight-bold">
                          <span>6. แผนการแก้ปัญหา ช่วยลดโอกาสเกิดซ้ำ หรือไม่</span>
                        </v-flex>
                      </v-layout>
                      <v-layout class="ml-6 mt-4">
                        <v-flex>
                          <v-radio-group :readonly="$route.query.read == 1 ? true : false" v-model="form.isHelp" row>
                            <v-radio style="padding-right: 70px" color="#3E7662" label="ช่วย" value="1"></v-radio>
                            <v-radio color="#3E7662" label="ไม่ช่วย" value="2"></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>

                      <!-- ข้อคิดเห็นและแนะนำ -->
                      <v-layout class="mb-4" style="margin-top: 100px">
                        <v-flex>
                          <span class="font-weight-bold">ข้อคิดเห็นและแนะนำ</span>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex>
                          <TextareaForm :readonly="$route.query.read == 1 ? true : false" :rows="8"
                            :model="form.adviceTextBox" @update-data="updateData('adviceTextBox', $event)" />
                        </v-flex>
                      </v-layout>

                      <!-- ผลการทบทวน -->
                      <v-layout mt-10>
                        <v-flex class="text-start font-weight-bold">
                          <span>ผลการทบทวน</span>
                        </v-flex>
                      </v-layout>
                      <v-layout class="ml-6 mt-4">
                        <v-flex shrink>
                          <v-radio-group :readonly="$route.query.read == 1 ? true : false" v-model="form.summary">
                            <v-radio class="mb-4" color="#3E7662" label="รับทราบ" value="1"></v-radio>
                            <v-radio class="mb-4" color="#3E7662" label="รับทราบ และมีข้อเสนอแนะหรือขอข้อมูลเพิ่มเติม"
                              value="2"></v-radio>
                            <v-radio color="#3E7662" label="นำเข้าพิจารณาในที่ประชุมคณะอนุกรรมการฯ" value="3"></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>

                      <!-- ผู้ประเมิน ทบทวน -->
                      <v-layout style="margin-top: 130px;">
                        <v-flex xs6>
                          <v-layout>
                            <v-flex xs3 mt-4 class="justify-start font-weight-bold d-flex align-center">
                              <span>ผู้ประเมิน ทบทวน</span>
                            </v-flex>
                            <v-flex xs6 class="text-start text-field-center">
                              <v-text-field :readonly="$route.query.read == 1 ? true : false" hide-details
                                v-model="form.signature" color="#3E7662" append-icon="edit" />
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs3></v-flex>
                            <v-flex xs6 class=" text-field-center">
                              <v-layout>
                                <v-flex mr-2 mt-5 shrink class="d-flex align-center">
                                  <span>(</span>
                                </v-flex>
                                <v-flex>
                                  <v-text-field :readonly="$route.query.read == 1 ? true : false
                                    " hide-details v-model="form.signature" color="#3E7662" />
                                </v-flex>
                                <v-flex ml-2 mt-5 shrink class="d-flex align-center">
                                  <span>)</span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-spacer></v-spacer>
                          </v-layout>
                        </v-flex>
                        <v-flex xs6 class="text-end">
                          <v-layout>
                            <v-spacer></v-spacer>
                            <v-flex shrink mr-4 class="text-end font-weight-bold d-flex align-center">
                              <span>วันที่ทบทวน</span>
                            </v-flex>
                            <v-flex xs6 class="text-end">
                              <TextfieldForm readonly v-if="$route.query.read == 1" hide-detail :model="dateChange" />
                              <DateInputForm v-else hide-detail :model="dateChange"
                                @update-data="updateDate('reviewDate', $event)" />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>

                      <!-- Date -->
                      <v-layout mt-8 style="margin-bottom: 60px;">
                        <v-flex xs3> </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <v-layout class="pl-12 pb-12">
                    <v-flex class="text-start font-weight-bold">
                      <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!-- Button Save -->
                <v-layout mt-8>
                  <v-flex mb-12 style="text-align: right;">
                    <v-layout>
                      <v-flex>
                        <v-btn style="color: #3E7662" class="mx-4" depressed color="#ffffff"
                          @click="$router.go(-1)">ย้อนกลับ</v-btn>
                        <v-btn depressed dark class="mx-4" color="#3E7662" @click="saveDraft">
                          <span>บันทึกข้อมูล</span>
                        </v-btn>
                        <v-btn v-if="$route.query.read == 0" depressed dark color="#3E7662" @click="save">
                          <span>บันทึกข้อมูลและส่งการประเมิน</span>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </div>

        <loading color="#527281" :active.sync="isLoading" :can-cancel="false" :is-full-pageAndLine="fullpageAndLine">
        </loading>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "../../components/input/TextfieldForm";
import DateInputForm from "../../components/input/DateInputForm";
import TextareaForm from "../../components/input/TextareaForm";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextfieldFormAppend from "../../components/input/TextfieldFormAppend";
import { mapState } from "vuex";
import domtoimage from "dom-to-image";

export default {
  name: "FormRO02",
  components: {
    TextfieldForm,
    DateInputForm,
    TextareaForm,
    Loading,
    TextfieldFormAppend,
  },
  data: () => ({
    formRf: false,
    isLoading: false,
    fullpageAndLine: true,
    form: {
      researchID: "",
      researchCode: "",
      firstName: "",
      lastName: "",
      researchName: "",
      numberOfReport: "",
      numberOfVolunteer: "",
      reportType: "",
      has1: false,
      event1: "",
      has2: false,
      event2: "",
      has3: false,
      event3: "",
      has4: false,
      event4: "",
      has5: false,
      event5: "",
      has6: false,
      event6: "",
      has7: false,
      event7: "",
      has8: false,
      event8: "",

      has9: false,
      event9: "",
      has10: false,
      event10: "",
      has11: false,
      event11: "",
      has12: false,
      event12: "",
      has13: false,
      event13: "",
      isRisk: "",
      risk: "",
      isScientific: "",
      scientific: "",
      isIntend: "",
      isIgnore: "",
      isAppropriate: "",
      isHelp: "",
      adviceTextBox: "",
      summary: "",
      signature: "",
      reviewDate: "",
    },
    allFormRf05: [],
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
    dateChange: "",
  }),
  watch: {
    checkbox1: function (val) {
      if (val) {
        this.form.reportType = "1";
        this.checkbox2 = false;
        this.checkbox3 = false;
        this.form.has9 = false;
        this.form.event9 = "";
        this.form.has10 = false;
        this.form.event10 = "";
        this.form.has11 = false;
        this.form.event11 = "";
        this.form.has12 = false;
        this.form.event12 = "";
        this.form.has13 = false;
        this.form.event13 = "";
      } else {
        this.form.has1 = false;
        this.form.event1 = "";
        this.form.has2 = false;
        this.form.event2 = "";
        this.form.has3 = false;
        this.form.event3 = "";
        this.form.has4 = false;
        this.form.event4 = "";
        this.form.has5 = false;
        this.form.event5 = "";
        this.form.has6 = false;
        this.form.event6 = "";
        this.form.has7 = false;
        this.form.event7 = "";
        this.form.has8 = false;
        this.form.event8 = "";
      }
    },
    checkbox2: function (val) {
      if (val) {
        this.form.reportType = "2";
        this.checkbox1 = false;
        this.form.has1 = false;
        this.form.event1 = "";
        this.form.has2 = false;
        this.form.event2 = "";
        this.form.has3 = false;
        this.form.event3 = "";
        this.form.has4 = false;
        this.form.event4 = "";
        this.form.has5 = false;
        this.form.event5 = "";
        this.form.has6 = false;
        this.form.event6 = "";
        this.form.has7 = false;
        this.form.event7 = "";
        this.form.has8 = false;
        this.form.event8 = "";
        this.checkbox3 = false;
        this.form.has9 = false;
        this.form.event9 = "";
        this.form.has10 = false;
        this.form.event10 = "";
        this.form.has11 = false;
        this.form.event11 = "";
        this.form.has12 = false;
        this.form.event12 = "";
        this.form.has13 = false;
        this.form.event13 = "";
      }
    },
    checkbox3: function (val) {
      if (val) {
        this.form.reportType = "3";
        this.checkbox1 = false;
        this.form.has1 = false;
        this.form.event1 = "";
        this.form.has2 = false;
        this.form.event2 = "";
        this.form.has3 = false;
        this.form.event3 = "";
        this.form.has4 = false;
        this.form.event4 = "";
        this.form.has5 = false;
        this.form.event5 = "";
        this.form.has6 = false;
        this.form.event6 = "";
        this.form.has7 = false;
        this.form.event7 = "";
        this.form.has8 = false;
        this.form.event8 = "";
        this.checkbox2 = false;
      }
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  created() {
    this.form.researchCode = this.$route.query.researchCode;
    this.form.researchName = this.$route.query.researchName;
    this.form.firstName = this.$route.query.firstName;
    this.form.lastName = this.$route.query.lastName;
    this.form.signature = this.user.thName;
    this.form.numberOfReport = this.$route.query.totalOfReport;
    this.form.numberOfVolunteer = this.$route.query.totalOfVolunteer;

    // this.checkbox1 = this.$route.query.checkbox1;
    // this.checkbox2 = this.$route.query.checkbox2;
    // this.form.has1 = this.$route.query.has1;
    // this.form.event1 = this.$route.query.event1;
    // this.form.has2 = this.$route.query.has2;
    // this.form.event2 = this.$route.query.event2;
    // this.form.has3 = this.$route.query.has3;
    // this.form.event3 = this.$route.query.event3;
    // this.form.has4 = this.$route.query.has4;
    // this.form.event4 = this.$route.query.event4;
    // this.form.has5 = this.$route.query.has5;
    // this.form.event5 = this.$route.query.event5;
    // this.form.has6 = this.$route.query.has6;
    // this.form.event6 = this.$route.query.event6;
    // this.form.has8 = this.$route.query.has8;
    // this.form.event8 = this.$route.query.event8;
    // this.form.has7 = this.$route.query.has7;
    // this.form.event7 = this.$route.query.event7;
    // this.form.checkbox3 = this.$route.query.checkbox3;
    // this.form.has9 = this.$route.query.has9;
    // this.form.event9 = this.$route.query.event9;
    // this.form.has10 = this.$route.query.has10;
    // this.form.event10 = this.$route.query.event10;
    // this.form.has11 = this.$route.query.has11;
    // this.form.event11 = this.$route.query.event11;
    // this.form.has12 = this.$route.query.has12;
    // this.form.event12 = this.$route.query.event12;
    // this.form.has13 = this.$route.query.has13;
    // this.form.event13 = this.$route.query.event13;

    let data = { date: new Date().toISOString().substr(0, 10) };
    this.updateDate("reviewDate", data);

    this.getRO08();
    this.getAllFormRf05();
  },
  methods: {
    async printPage() {
      this.printMode = true
      document.getElementsByClassName("print-form")[0].style.backgroundColor =
        "#fff";
      await document.querySelectorAll("button").forEach(function (element) {
        element.style.display = 'none'
      });
      await document.querySelectorAll(".v-icon").forEach(function (element) {
        element.style.display = 'none'
      });
      await document.getElementsByClassName("v-input--checkbox v-input--is-label-active").forEach(function (element) {
        element.innerHTML = '✓' + element.innerHTML
      })
      await document.getElementsByClassName("v-radio v-item--active").forEach(function (element) {
        element.innerHTML = '✓ ' + element.innerHTML
      })
      var node = document.getElementById("print");
      var self = this;
      domtoimage
        .toPng(node)
        .then(async function (dataUrl) {
          var img = new Image();
          img.src = dataUrl;
          var page = self.imageToPrint(img);

          var pageLink = "about:blank";
          var pwa = window.open(pageLink, "_new");
          pwa.document.open();
          pwa.document.write(page);
          pwa.document.close();
          self.printMode = false
          await document.querySelectorAll("button").forEach(function (element) {
            element.style.display = 'unset'
          });
          await document.getElementsByClassName("v-input--checkbox v-input--is-label-active").forEach(function (element) {
            element.innerHTML = element.innerHTML.replace('✓', '')
          })
          await document.getElementsByClassName("v-radio v-item--active").forEach(function (element) {
            element.innerHTML = element.innerHTML.replace('✓ ', '')
          })
          await document.querySelectorAll(".v-icon").forEach(function (element) {
            element.style.display = 'unset'
          });
          document
            .getElementsByClassName("print-form")[0]
            .removeAttribute("style");
        })
        .catch(function (error) {
          Swal.fire({
            title: "กรุณาเปิดการอนุญาต Pop Up!",
            description: "",
            icon: "error",
            confirmButtonColor: "#3E7662",
            cancelButtonColor: "rgb(189, 189, 189)",
            confirmButtonText: "ตกลง",
          }).then(async function () {

            await document.querySelectorAll("button").forEach(function (element) {
              element.style.display = 'unset'
            });
            await document.getElementsByClassName("v-input--checkbox v-input--is-label-active").forEach(function (element) {
              element.innerHTML = element.innerHTML.replace('✓', '')
            })
            await document.getElementsByClassName("v-radio v-item--active").forEach(function (element) {
              element.innerHTML = element.innerHTML.replace('✓ ', '')
            })
            await document.querySelectorAll(".v-icon").forEach(function (element) {
              element.style.display = 'unset'
            });
            document
              .getElementsByClassName("print-form")[0]
              .removeAttribute("style");
          })
        });
    },
    imageToPrint(source) {
      return (
        "<html><body onload='window.print()'><style>@media print {\n" +
        "  @page { margin: 0; }\n" +
        "  html, body {\n" +
        "    margin: 0;\n" +
        "    width: 210mm;\n" +
        "    height: 297mm;\n" +
        "  }\n" +
        "  img {\n" +
        "    margin-top: 10mm;\n" +
        "    margin-left: 20mm;\n" +
        "    width: 170mm;\n" +
        // "    height: 297mm;\n" +
        "  }\n" +
        "}</style>" +
        source.outerHTML +
        "</body></html>"
      );
    },
    viewFormRf05(researchID, id) {
      let routeData = this.$router.resolve({
        name: "ViewFormRF05",
        query: {
          id: researchID,
          rfID: id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    async getAllFormRf05() {
      let { data } = await this.$store.dispatch(
        "FormRF/getDeviationReportByIdResearch",
        this.$route.query.id
      );
      this.allFormRf05 = data;
    },

    updateData(name, val) {
      this.form[name] = val;
    },

    updateDate(name, val) {
      if (name === "reviewDate") {
        this.form.reviewDate = val.date;
        this.dateChange = this.changeDate(val.date);
      }
      if (name === "reviewDateGet") {
        this.form.reviewDate = val;
        this.dateChange = this.changeDate(val);
      }
    },

    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);
      sub_year = parseInt(sub_year) + 543;
      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },

    clearCheckbox(name) {
      if (name === "has1" && !this.form.has1) {
        this.form.event1 = "";
      }
      if (name === "has2" && !this.form.has2) {
        this.form.event2 = "";
      }
      if (name === "has3" && !this.form.has3) {
        this.form.event3 = "";
      }
      if (name === "has4" && !this.form.has4) {
        this.form.event4 = "";
      }
      if (name === "has5" && !this.form.has5) {
        this.form.event5 = "";
      }
      if (name === "has6" && !this.form.has6) {
        this.form.event6 = "";
      }
      if (name === "has7" && !this.form.has7) {
        this.form.event7 = "";
      }
      if (name === "has8" && !this.form.has8) {
        this.form.event8 = "";
      }
      if (name === "has9" && !this.form.has9) {
        this.form.event9 = "";
      }
      if (name === "has10" && !this.form.has10) {
        this.form.event10 = "";
      }
      if (name === "has11" && !this.form.has11) {
        this.form.event11 = "";
      }
      if (name === "has12" && !this.form.has12) {
        this.form.event12 = "";
      }
      if (name === "has13" && !this.form.has13) {
        this.form.event13 = "";
      }
    },

    clearRadio(name) {
      if (name === "isRisk") {
        this.form.risk = "";
      }
      if (name === "isScientific") {
        this.form.scientific = "";
      }
    },

    save() {
      Swal.fire({
        title: "คุณต้องการบันทึกหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึก",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.form["researchID"] = this.$route.query.id;
          this.form["rfID"] = this.$route.query.rfID;
          this.$store
            .dispatch("FormRO/saveRO08", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$router.go(-1);
              });
              this.isLoading = false;
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
              // Swal.fire({
              //     title: 'Save failed!',
              //     text: 'บันทึกไม่สำเร็จ',
              //     icon: 'warning',
              // })
              // this.isLoading = false;
            });
        }
      });
    },
    saveDraft() {
      Swal.fire({
        title: "คุณต้องการบันทึกหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึก",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.form["researchID"] = this.$route.query.id;
          this.form["rfID"] = this.$route.query.rfID;
          this.$store
            .dispatch("FormRO/saveDraftRO08", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$router.go(-1);
              });
              this.isLoading = false;
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
              // Swal.fire({
              //     title: 'Save failed!',
              //     text: 'บันทึกไม่สำเร็จ',
              //     icon: 'warning',
              // })
              // this.isLoading = false;
            });
        }
      });
    },

    getRO08() {
      this.isLoading = true;
      this.$store
        .dispatch("FormRO/getRO08", this.$route.query.rfID)
        .then((res) => {
          if (res !== "don't have ro08 yet") {
            console.log("res : ", res);
            this.form.researchID = res.researchID;
            this.form.researchCode = res.researchCode;
            this.form.firstName = res.firstName;
            this.form.lastName = res.lastName;
            this.form.researchName = res.researchName;
            this.form.numberOfReport = res.numberOfReport;
            this.form.numberOfVolunteer = res.numberOfVolunteer;
            switch (res.reportType) {
              case 1:
                this.checkbox1 = true;
                break;
              case 2:
                this.checkbox2 = true;
                break;
              case 3:
                this.checkbox3 = true;
                break;
            }
            this.form.has1 = res.has1;
            this.form.event1 = res.event1;
            this.form.has2 = res.has2;
            this.form.event2 = res.event2;
            this.form.has3 = res.has3;
            this.form.event3 = res.event3;
            this.form.has4 = res.has4;
            this.form.event4 = res.event4;
            this.form.has5 = res.has5;
            this.form.event5 = res.event5;
            this.form.has6 = res.has6;
            this.form.event6 = res.event6;
            this.form.has7 = res.has7;
            this.form.event7 = res.event7;
            this.form.has8 = res.has8;
            this.form.event8 = res.event8;
            this.form.has9 = res.has9;
            this.form.event9 = res.event9;
            this.form.has10 = res.has10;
            this.form.event10 = res.event10;
            this.form.has11 = res.has11;
            this.form.event11 = res.event11;
            this.form.has12 = res.has12;
            this.form.event12 = res.event12;
            this.form.has13 = res.has13;
            this.form.event13 = res.event13;
            this.form.isRisk = res.isRisk.toString();
            this.form.risk = res.risk;
            this.form.isScientific = res.isScientific.toString();
            this.form.scientific = res.scientific;
            this.form.isIntend = res.isIntend.toString();
            this.form.isIgnore = res.isIgnore.toString();
            this.form.isAppropriate = res.isAppropriate.toString();
            this.form.isHelp = res.isHelp.toString();
            this.form.adviceTextBox = res.adviceTextBox;
            this.form.summary = res.summary.toString();
            this.form.signature = res.signature;
            this.updateDate("reviewDateGet", res.reviewDate);
          }
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },

    setData() {
      this.form.researchID = "researchIDTest";
      this.form.researchCode = "researchCodeTest";
      this.form.firstName = "firstNameTest";
      this.form.lastName = "lastNameTest";
      this.form.researchName = "researchNameTest";
      this.form.numberOfReport = "30";
      this.form.numberOfVolunteer = "199";
      this.form.has1 = false;
      this.form.event1 = "";
      this.form.has2 = false;
      this.form.event2 = "";
      this.form.has3 = false;
      this.form.event3 = "";
      this.form.has4 = false;
      this.form.event4 = "";
      this.form.has5 = false;
      this.form.event5 = "";
      this.form.has6 = false;
      this.form.event6 = "";
      this.form.has7 = false;
      this.form.event7 = "";
      this.form.has8 = true;
      this.form.event8 = "event8Test";
      this.form.has9 = true;
      this.form.event9 = "event9Test";
      this.form.has10 = true;
      this.form.event10 = "event10Test";
      this.form.has11 = true;
      this.form.event11 = "event11Test";
      this.form.has12 = true;
      this.form.event12 = "event12Test";
      this.form.has13 = true;
      this.form.event13 = "event13Test";
      this.form.isRisk = "1";
      this.form.risk = "riskTest";
      this.form.isScientific = "1";
      this.form.scientific = "scientificTest";
      this.form.isIntend = "1";
      this.form.isIgnore = "1";
      this.form.isAppropriate = "1";
      this.form.isHelp = "1";
      this.form.adviceTextBox = "adviceTextBoxTest";
      this.form.summary = "1";
      this.form.signature = "signatureTest";
      this.updateDate("reviewDateGet", "2020-02-02");
    },
  },
};
</script>

<style lang="scss">
.table-ro4-1 {

  /*** Table Styles **/
  .table-style-ro04-1 {
    .v-input__slot {
      align-items: center;
      justify-content: center;
    }

    .table-fill-ro04-1 {
      background: white;
      border-radius: 3px;
      border-collapse: collapse;
      margin: auto;
      padding: 5px;
      width: 100%;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
      animation: float 5s infinite;
      /*border-bottom: 5px solid #544A44;*/
    }

    th {
      color: #ffffff;
      background: #3e7662;
      /*border-top:5px solid #544A44;*/
      border-right: 0.75px solid gray;
      font-weight: 700;
      padding: 15px;
      vertical-align: middle;
    }

    tr {
      border-top: 1px solid #544a44;
      border-bottom-: 1px solid #544a44;
    }

    th:first-child {
      border-top-left-radius: 3px;
    }

    th:last-child {
      border-top-right-radius: 3px;
      border-right: none;
    }

    tr:first-child {
      /*border-top: none;*/
    }

    tr:last-child {
      /*border-bottom:5px solid #544A44;*/
    }

    tr:last-child td:first-child {
      border-bottom-left-radius: 3px;
    }

    tr:last-child td:last-child {
      border-bottom-right-radius: 3px;
    }

    td {
      background: #ffffff;
      padding: 10px 30px 10px 30px;
      text-align: left;
      vertical-align: middle;
      font-weight: 700;
      color: black;
      border-right: 0.5px solid gray;
      border-top: 0.5px solid gray;
    }

    td:last-child {
      border-right: 0px;
    }

    th.text-left {
      text-align: left;
    }

    th.text-center {
      text-align: center;
    }

    th.text-right {
      text-align: right;
    }

    td.text-left {
      text-align: left;
    }

    td.text-center {
      text-align: center;
    }

    td.text-right {
      text-align: right;
    }
  }
}

.text-field-color {

  .theme--light.v-input,
  .theme--light.v-input input,
  .theme--light.v-input textarea {
    color: #cc3d45;
  }
}

.text-field-margin {
  .v-text-field {
    padding: 0;
    margin: 0;
  }
}
</style>